
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/marketplace/edo",
      function () {
        return require("private-next-pages/[locale]/marketplace/edo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/marketplace/edo"])
      });
    }
  